function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });

    }

  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('!sp-overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add('open-modal');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
   // window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('!sp-overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove('open-modal');
    removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      // DD: ignore gallery on desktop only
      if(this.classList.contains('product__modal-opener') && window.innerWidth <= 768) return;

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) {
        modal.show(button);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    // media query for mobile threshold
    this.mq = window.matchMedia('(max-width: 750px)');
    this.mq.addEventListener?.('change', () => {
      this.initPages();
      this.updateA11y();
    });

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', () => {
      this.update();
      this.updateA11y();
    });
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // DD: taken from feature-carousel.js
    this.itemSelectors = this.querySelectorAll('.item-selectors > div')
    this.itemSelectors.forEach((item, i) => {
      item.addEventListener('click', this.onPaginationClick.bind(this, i))
    })

    this.initPages();
    this.updateA11y();
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth);

    // DD: Taken from feature-carousel
    this.itemSelectors.forEach((item, i) => {
      item.style.opacity = this.currentPage == i ? '1.0' : '0.5'
    })

    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton?.setAttribute('disabled', true);
    } else {
      this.prevButton?.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  updateA11y() {
    if (!this.sliderItems?.length) return;
    const isMobile = this.mq.matches;

    if (!isMobile) {
      this.sliderItems.forEach(li => li.setAttribute('aria-hidden', 'false'));
      return;
    }

    const currentIndex = Math.round(
      this.slider.scrollLeft / (this.sliderLastItem?.clientWidth || this.slider.clientWidth)
    );

    this.sliderItems.forEach((li, i) => {
      li.setAttribute('aria-hidden', i === currentIndex ? 'false' : 'true');
    });
  }

  onPaginationClick(i) {
    // console.log('onPaginationClick',i)
    const slideScrollPosition = window.innerWidth * i;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onButtonClick(event) {
    // console.log('onButtonClick')
    event.preventDefault();
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + window.innerWidth : this.slider.scrollLeft - window.innerWidth;
    this.slider.scrollTo({
      left: (slideScrollPosition > this.slider.scrollWidth) ? 0 : slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isUpdatingBIS = false;

    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects')) {
        this.onVariantChange();
        return;
      }

      if (!e.target.closest('input')) return;
      this.onVariantChange();
    });
    this.addEventListener('click', (e) => {
      const colorClicked = e.target.closest('[data-action="color-select"]');
      if (!colorClicked) return;

      this.getVariantData();
      this.updateVariantSelects(colorClicked.title);
    });
  }

  onVariantChange() {
    if (document.querySelector('[name="pack-size"]:not([value="1"]):checked')) {
      const color = document.querySelector('input[name="Color"]:checked')?.value?.split('/')?.pop();
      this.currentVariant = this.variantData?.find(x => x.options.includes(color));
      if (!this.currentVariant) return
      this.updateMedia();
      return;
    }
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
    this.updateBIS()
  }

  updateBIS() {
    if (this.isUpdatingBIS) return;
      this.isUpdatingBIS = true;
      document.querySelector('[data-main-select]')?.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    this.isUpdatingBIS = false;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        if (this.options[index]) {
          return this.options[index] === option;
        }
      }).includes(false);
    });    
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMediaAll = document.querySelectorAll(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    newMediaAll.forEach(newMedia => {
      if (!newMedia) return;
      
      const modalImagesContainer = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__images`);
      const newMediaModal = modalImagesContainer.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      const imageTotal = parseInt(parent.dataset.imageTotal) || parseInt(parent.closest('[data-image-total]')?.dataset.imageTotal);

      // DD: Old logic to move selected variant item to the top
      //if (parent.firstChild == newMedia) return;
      //modalContent.prepend(newMediaModal);
      //parent.prepend(newMedia);

      // DD: New logic to show top five media for variant
      parent.querySelectorAll('li').forEach((el) => el.classList.add('slider-image-hidden'))
      var nextSibling = newMedia;
      for(var i = 1; i <= imageTotal; i++) {
        nextSibling?.classList?.remove('slider-image-hidden')
        nextSibling = nextSibling?.nextSibling
      }
      
      // DD: New logic to update the modal gallery
      var newMediaModalIndex = null
      document.querySelectorAll('product-gallery [data-media-id]').forEach((el, index) => {
        el.classList.add('slider-image-hidden')


        if(el.dataset.mediaId === newMediaModal.dataset.mediaId) {
          newMediaModalIndex = index
        }

        if(newMediaModalIndex != null && index == newMediaModalIndex) el.classList.add('active')
        if(newMediaModalIndex != null && index < newMediaModalIndex + imageTotal) {
          // console.log(index, newMediaModalIndex, imageTotal, el)
          el.classList.remove('slider-image-hidden')
        }
      });

      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if(this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      // DD: Turned off becuase product images are reordered
      //window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
    });
    
    const temp = document.createElement('div');
    const imagesTemplate = document.querySelector('[data-all-product-images]');
    const imageTotal = parseInt(imagesTemplate.dataset.imageTotal);
    temp.innerHTML = imagesTemplate.innerHTML;
    const newSlidesNode = document.createElement('div');
    
    const allSlides = [...temp.querySelectorAll('[data-media-id]')];
    const startIndex = allSlides.findIndex(
      el => el.dataset.mediaId === `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );

    for (let i = 0; i < imageTotal; i++) {
      const slide = allSlides[startIndex + i];
      if (!slide) break;
      newSlidesNode.append(slide);
      //console.log(`slide`, slide);
    }
    
    const slides = Array.from(newSlidesNode.children);
    document.querySelectorAll('.grid__item.product__media-wrapper swiper-container').forEach(swiperEl => {
      swiperEl.innerHTML = '';
      slides.forEach(s => {
        const slide = s.tagName === 'SWIPER-SLIDE' ? s.cloneNode(true) : Object.assign(document.createElement('swiper-slide'), { innerHTML: s.outerHTML });
        if (swiperEl.hasAttribute('thumbs-swiper')) {
          slide.setAttribute('data-image-container', true);
          slide.querySelectorAll('img').forEach(img => {
            ['src','srcset'].forEach(a => { if (img[a]) img[a] = img[a].replace(/width=200/g,'width=600').replace(/200w/g,'600w'); });
            if (img.width === 200) img.width = 600;
          });
        }
        swiperEl.appendChild(slide);
      });

      if (swiperEl.hasAttribute('thumbs-swiper')) {
        const imgs = Array.from(swiperEl.querySelectorAll('swiper-slide img'));
        const videos = Array.from(swiperEl.querySelectorAll('swiper-slide video'));
        const first = imgs[0];
        if (first && !window.__preloaded600) {
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = first.currentSrc || first.src;
          if (first.srcset) link.setAttribute('imagesrcset', first.srcset);
          if (first.sizes) link.setAttribute('imagesizes', first.sizes);
          document.head.appendChild(link);
          first.fetchPriority = 'high';
          first.loading = 'eager';
          first.decoding = 'async';
          window.__preloaded600 = true;
        }
        imgs.slice(1, 3).forEach(img => { const i = new Image(); i.src = img.currentSrc || img.src; });
        videos.forEach(video => {
          video.autoplay = true;
          video.controls = true;
        });
      }

      if (swiperEl.swiper) swiperEl.swiper.update();
      else if (swiperEl.initialize) swiperEl.initialize();
    });

  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantSelects(newColor) {
    if (this.colorIndex === false) return;  
    let newColorVariants = this.variantData.filter(
      variant => variant.options[this.colorIndex] === newColor
    );
  
    const inputs = this.querySelectorAll('input[name]:not([data-color-input]):not([name="Color"])');
  
    inputs.forEach((input) => {
      const inputName = input.name;  
      const allOptionNames = Array.from(
        this.querySelectorAll('input[name]')
      )
        .map(input => input.name)
        .filter((name, idx, arr) => arr.indexOf(name) === idx); 
  
      const optionIndex = allOptionNames.indexOf(inputName);  
      if (optionIndex === -1) return;
  
      const variantMatch = newColorVariants.find(variant => {
        return variant.options[optionIndex] === input.value;
      });
  
      if (variantMatch?.available) {
        input.parentNode.classList.remove("tw-opacity-50", "option-unavailable");
      } else {
        input.parentNode.classList.add("tw-opacity-50", "option-unavailable");
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinations = document.querySelectorAll('div:has(>[data-price-renderer])');
        const source = html.getElementById(id);
        
        destinations.forEach(destination => {
          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        const price = document.getElementById(`price-${this.dataset.section}`);
        const regularPrice = price?.querySelector('.price__compare .price-item--regular')?.innerText ?? false;
        const salePrice = price?.querySelector('.price-item--sale')?.innerText ?? false;
        const quantity = document.querySelector('input[name="Quantity"]:checked')?.value ?? null;
        document.dispatchEvent(new CustomEvent('variantSelection:priceInfo',{ detail: { regularPrice, salePrice, quantity }}))
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const additionalPayButtons = productForm.querySelector('[data-extra-wrapper]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      addButton.classList.add('sp-hidden');
      additionalPayButtons?.classList.add('sp-hidden');
      if (text) addButtonText.textContent = text;
    } else {
      let use_size_text = false;
      let size_selected = false;
      const data_size_selector = document.querySelector('[data-size-selector]');

      if (data_size_selector) {
        use_size_text = true;

        const radios = data_size_selector.querySelectorAll('input[type="radio"]');

        for (const radio of radios) {
          if (radio.checked) {
            size_selected = true;
            break;
          }
        }
      }

      addButton.removeAttribute('disabled');
      addButton.classList.remove('sp-hidden');
      additionalPayButtons?.classList.remove('sp-hidden');
      addButtonText.textContent = use_size_text ? (size_selected ? window.variantStrings.addToCart : 'Select a size') : window.variantStrings.addToCart;
    }
    if (!modifyClass) return; 
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    const variantJson = this.querySelector('[type="application/json"]');
    this.colorIndex = variantJson.dataset.colorIndex == 'false' ? false : Number(variantJson.dataset.colorIndex);
    this.variantData = this.variantData || JSON.parse(variantJson.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  updatePackSizeOptions() {
    const current_color = this.currentVariant.option1;
    const current_size = this.currentVariant.option2;
    const filtered_variants = this.variantData.filter(variant => variant.option1 === current_color && variant.option2 === current_size);
    const pack_size_inputs = document.querySelectorAll('input[type="radio"][data-action="pack-select"]');

    pack_size_inputs.forEach(input => {
      filtered_variants.forEach((variant) => {
        if (variant.options.includes(current_size) && variant.options.includes(current_color) && variant.options.includes(input.value)) {
          if (variant.available) {
            input.parentNode.classList.remove("tw-opacity-50", "option-unavailable");
          } else {
            input.parentNode.classList.add("tw-opacity-50", "option-unavailable");
          }
        }
      });
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
